import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Heat from './pages/Heat';
import Winds from './pages/Winds';
import Cold from './pages/Cold';
import Flood from './pages/Flood';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
// import UilReact from '@iconscout/react-unicons/icons/uil-react'

function App() {
  return (
    <div className="App">
      <Router>
      <Navbar />
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route path='/heat' element={<Heat/>} />
        <Route path='/winds' element={<Winds/>} />
        <Route path='/flood' element={<Flood/>} />
        <Route path='/cold' element={<Cold/>} />
      </Routes>
      <Footer />
      </Router>
    </div>
  );
}

export default App;
